module.exports = __webpack_public_path__ + "static/media/iconCalendar.35893b42.svg";